/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from "react";
import {
  Table,
  Modal,
  Button,
  Form,
  Col,
  Row,
  InputGroup,
  Dropdown,
} from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import { useTranslate } from "../hooks/LanguageProvider";
import { PagePermission } from "../utilities/permissions";
import { PropagateLoader } from "react-spinners";
import "../assets/css/simcards.css";
const backendUrl = process.env.REACT_APP_BACKEND_URL;

interface SimCardsItem {
  id_puce: number;
  numero_puce: string;
  operateur_puce: string;
  date_creation_carte_sim: string;
  contrat_puce: string;
  serial_number: string;
  type_puce?: string;
  totalpuces: number;
  id_user: string;
}

interface DeletedSimcardsItem {
  id_puce: number;
  numero_puce: string;
  operateur_puce: string;
  date_creation_carte_sim: string;
  contrat_puce: string;
  serial_number: string;
}
// END interface

// FR: Pagination du tableau
let currentPage = 1;

const getOperatorCode = (operator?: string, phone?: string) => {
  const value = (operator || "").toLowerCase();

  if (value === "5" || value.includes("ooredoo")) return "5";
  if (value === "6" || value.includes("mobilis")) return "6";
  if (value === "7" || value.includes("djezzy")) return "7";

  const normalizedPhone = (phone || "").replace(/\D/g, "");
  if (normalizedPhone.startsWith("213") && normalizedPhone.length > 3) {
    return normalizedPhone.charAt(3);
  }
  if (normalizedPhone.startsWith("0") && normalizedPhone.length > 1) {
    return normalizedPhone.charAt(1);
  }

  return "";
};

const getOperatorName = (operatorCode: string) => {
  if (operatorCode === "5") return "Ooredoo";
  if (operatorCode === "6") return "Mobilis";
  if (operatorCode === "7") return "Djezzy";
  return "";
};

const getPhoneSuffix = (phone?: string, operatorCode?: string) => {
  let value = (phone || "").replace(/\D/g, "");

  if (value.startsWith("00213")) value = value.slice(5);
  if (value.startsWith("213")) value = value.slice(3);
  if (value.startsWith("0")) value = value.slice(1);
  if (operatorCode && value.startsWith(operatorCode)) value = value.slice(1);

  return value.slice(0, 8);
};

const getOperatorBadgeClass = (operator?: string) => {
  const code = getOperatorCode(operator);
  if (code === "5") return "sim-operator-ooredoo";
  if (code === "6") return "sim-operator-mobilis";
  if (code === "7") return "sim-operator-djezzy";
  return "sim-operator-default";
};

const formatSortValue = (item: SimCardsItem, type: keyof SimCardsItem) => {
  const value = item[type];
  if (type === "date_creation_carte_sim") {
    return new Date(String(value || "")).getTime();
  }
  if (typeof value === "number") return value;
  return String(value || "").toLowerCase();
};

export function Simcards() {
  // Start State
  const { translate } = useTranslate();
  const user_id = localStorage.getItem("userid");
  const [loading, setLoading] = useState(true);

  const [column, setSortColum] = useState(0);
  const [sort, setSort] = useState("ASC");
  const [search, setSearch] = useState("");
  const [type, setType] = useState(1);
  const [simCardsList, setSimCardsList] = useState<SimCardsItem[]>([]);
  const [total, setTotal] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [typeSearch, setTypeSearch] = useState("SIM card number");
  const [selectedSearch, setSelectedSearch] = useState(translate("SIM card number"));
  const [simCardNum, setSimCardNum] = useState("");
  const [phoneNumberPrefix, setPhoneNumberPrefix] = useState("+213");
  const updatePhoneNumberPrefix = (operator: string) => {
    let prefix = "+213";
    switch (operator) {
      case "5":
        prefix += "5";
        break;
      case "7":
        prefix += "7";
        break;
      case "6":
        prefix += "6";
        break;
      default:
        prefix = "+213"; // Par défaut, si l'opérateur n'est pas sélectionné
    }
    setPhoneNumberPrefix(prefix);
  };
  const [imeiNumber, setImeiNumber] = useState("");
  const [contratType, setContratType] = useState("");
  const [simcardType, setSimcardType] = useState("");
  const [simcardOperator, setSimcardOperator] = useState("");
  const [selectedUser, setSelectedUser] = useState("0");
  const [selectedSimcardID, setSelectedSimcardID] = useState<number>(0);
  const [affecteAOptions, setAffecteAOptions] = useState<Array<{ label: string; value: string }>>([]);
  const [showModal, setShowModal] = useState(false);
  const [showDeletedModal, setShowDeletedModal] = useState(false);
  const [confirmUpdate, setConfirmUpdate] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [titleModal, setTitleModal] = useState("");

  // InTrash
  const [deletedSimcardCount, setDeletedSimcardCount] = useState<number>(0);
  const [deletedSimcards, setDeletedSimcards] = useState<DeletedSimcardsItem[]>(
    []
  );
  const [showDeletedSimcardsModal, setShowDeletedSimcardsModal] =
    useState(false);
  // END InTrash

  // Trie dans le tableux
  const [sortType, setSortType] = useState<
    | "id_puce"
    | "operateur_puce"
    | "numero_puce"
    | "contrat_puce"
    | "serial_number"
    | "date_creation_carte_sim"
  >("id_puce");
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");
  // END State


    const searchColumn: { [key: string]: number } = {
    id_vehicule: 0,
    vehicule_type: 1,
    immatriculation_vehicule: 2,
    PSN:  3,
    username_user: 4,
    nom_groupe: 5,
    odometer: 6,
  };

  // Function to retrieve and display the data with the number of chips
  const getSimCards = async (
    limit: number,
    currentPage: number,
    search: string,
    type: number,
    column: number,
    sort: string,
  ) => {
    try {
       setLoading(true);
      const postData = {
        id_user: user_id,
        page: currentPage,
        limit,
        search,
        type,
        column,
        sort,
      };

      // POST request for total, including filters if they are managed server-side

      const total_pages = await fetch(`${backendUrl}/api/simcards/totalpage`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify( postData),
        mode: "cors",
      });

      const totalPages = await total_pages.json();
      const total = totalPages[0].total;
      setTotal(total);
      const calculatedPageCount = Math.ceil(total / limit);
      setPageCount(calculatedPageCount);


      const simCardData = await fetch(`${backendUrl}/api/simcards/search`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify( postData ),
        mode: "cors",
      });

      const data = await simCardData.json();
      setSimCardsList(data);

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };


  const refreshSimCardData = async () => {
    getSimCards(limit, currentPage, search, type, column, sort);
  };

  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([refreshSimCardData(), fetchDeletedSimCardCount()]);
    };

    fetchData();
  }, [user_id, limit, type, sort]);

  const handlePageClick = async (data: { selected: number }) => {
    currentPage = data.selected + 1;
    refreshSimCardData();
  };

  const isLuhnValid = (number: string) => {
    const digits = number.toString().split('').map(Number);
    let sum = 0;
    let alternate = false;

    for (let i = digits.length - 1; i >= 0; i--) {
      let currentDigit = digits[i];

      if (alternate) {
        currentDigit *= 2;
        if (currentDigit > 9) {
          currentDigit -= 9;
        }
      }

      sum += currentDigit;
      alternate = !alternate;
    }

    return sum % 10 === 0;
  };
  // Function New Simcarde Vehicules
  const handleConfirmSaveModal = async () => {
    if (!isLuhnValid(imeiNumber)) {
      setErrorMessage(translate("Invalid IMEI number."));
      return;
    }

    if (
      !simCardNum ||
      !simcardOperator ||
      !selectedUser ||
      !simcardOperator ||
      !contratType ||
      !simcardType ||
      !imeiNumber
    ) {
      setErrorMessage(translate("Please complete all required fields."));
      return;
    }
    if (selectedUser === "0") {
      // Utilisateur non sélectionné
      setErrorMessage(translate("Please select a user."));
      return;
    }

    const operateur_puce = getOperatorName(simcardOperator);

    // Vérifiez si tous les champs requis sont remplis
    try {
      const response = await fetch(`${backendUrl}/api/simcards/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id_user: selectedUser,
          numero_puce: "0" + simcardOperator + simCardNum,
          operateur_puce: operateur_puce,
          type_puce: simcardType,
          contrat_puce: contratType,
          serial_number: imeiNumber,
        }),
      });
      if (!response.ok) {
        throw new Error(`Erreur HTTP! Status: ${response.status}`);
      }
      // const data = await response.json();
      alert(`Simcard successfully created`);
      handleCloseModal(); // Fermez le modal après la création réussie
      setSimCardNum("");
      setSimcardOperator("");
      setShowModal(false);
      getSimCards(limit, currentPage, search, type, column, sort);
    } catch (error) {
      console.error("Erreur lors de la création du simcard:", error);
    }
  };

  // Selection option user
  const fetchAffecteAOptions = async () => {
    try {
      const response = await fetch(
        `${backendUrl}/api/simcards/options/user/${user_id}`
      );
      const data = await response.json();
      if (Array.isArray(data)) {
        setAffecteAOptions(
          data.map((user) => ({
            label: `${user.nom_user} ${user.prenom_user}`,
            value: user.id_user,
          }))
        );
      } else {
        console.error("La réponse de l'API n'est pas un tableau :", data);
      }
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des options du sélecteur",
        error
      );
    }
  };

  // Start Fonction pour le trie dans le tableau

  const handleSort = async (
    type:
      | "id_puce"
      | "operateur_puce"
      | "numero_puce"
      | "contrat_puce"
      | "serial_number"
      | "date_creation_carte_sim"
  ) => {
    let sortOrder: "asc" | "desc" = "asc";

    if (type === sortType) {
      sortOrder = sortDirection === "asc" ? "desc" : "asc";
    }
    setSortType(type);
    setSortDirection(sortOrder);
  };

  const sortedSimCardsList = Array.isArray(simCardsList)
    ? [...simCardsList].sort((firstItem, secondItem) => {
        const firstValue = formatSortValue(firstItem, sortType);
        const secondValue = formatSortValue(secondItem, sortType);

        if (firstValue < secondValue) return sortDirection === "asc" ? -1 : 1;
        if (firstValue > secondValue) return sortDirection === "asc" ? 1 : -1;
        return 0;
      })
    : [];

  const renderSortIcon = (
    type:
      | "id_puce"
      | "operateur_puce"
      | "numero_puce"
      | "contrat_puce"
      | "serial_number"
      | "date_creation_carte_sim"
  ) => {
    if (sortType !== type) return <i className="las la-sort sim-sort-icon"></i>;
    return (
      <i
        className={`las ${
          sortDirection === "asc" ? "la-sort-up" : "la-sort-down"
        } sim-sort-icon active`}
      ></i>
    );
  };

  const TableHeader = () => {
    return (
      <thead className="bg-white text-uppercase">
        <tr className="ligth ligth-data">
          <th>
            <div className="checkbox d-inline-block">
              <input
                type="checkbox"
                className="checkbox-input"
                id="checkbox1"
              />
              <label htmlFor="checkbox1" className="mb-0"></label>
            </div>
          </th>
          <th style={{ width: "199px", cursor: "pointer" }}>
            <span
              onClick={() => handleSort("id_puce")}
              style={{ color: "#140A57" }}
            >
              {translate("ID")}
              {sortType === "id_puce" && sortDirection === "asc" && " ▲"}
              {sortType === "id_puce" && sortDirection === "desc" && " ▼"}
            </span>
          </th>
          <th style={{ width: "199px", cursor: "pointer" }}>
            <span
              onClick={() => handleSort("operateur_puce")}
              style={{ color: "#140A57" }}
            >
              {translate("Operator")}
              {sortType === "operateur_puce" && sortDirection === "asc" && " ▲"}
              {sortType === "operateur_puce" &&
                sortDirection === "desc" &&
                " ▼"}
            </span>
          </th>
          <th style={{ width: "199px", cursor: "pointer" }}>
            <span
              onClick={() => handleSort("numero_puce")}
              style={{ color: "#140A57" }}
            >
              {translate("Phone")}
              {sortType === "numero_puce" && sortDirection === "asc" && " ▲"}
              {sortType === "numero_puce" && sortDirection === "desc" && " ▼"}
            </span>
          </th>
          <th style={{ width: "199px", cursor: "pointer" }}>
            <span
              onClick={() => handleSort("contrat_puce")}
              style={{ color: "#140A57" }}
            >
              {translate("Type of Contract")}
              {sortType === "contrat_puce" && sortDirection === "asc" && " ▲"}
              {sortType === "contrat_puce" && sortDirection === "desc" && " ▼"}
            </span>
          </th>
          <th style={{ width: "199px", cursor: "pointer" }}>
            <span
              onClick={() => handleSort("serial_number")}
              style={{ color: "#140A57" }}
            >
              {translate("Serial number")}
              {sortType === "serial_number" && sortDirection === "asc" && " ▲"}
              {sortType === "serial_number" && sortDirection === "desc" && " ▼"}
            </span>
          </th>
          <th style={{ width: "199px", cursor: "pointer" }}>
            <span
              onClick={() => handleSort("date_creation_carte_sim")}
              style={{ color: "#140A57" }}
            >
              {translate("Creation date")}
              {sortType === "date_creation_carte_sim" &&
                sortDirection === "asc" &&
                " ▲"}
              {sortType === "date_creation_carte_sim" &&
                sortDirection === "desc" &&
                " ▼"}
            </span>
          </th>

          <th>{translate("Actions")}</th>
        </tr>
      </thead>
    );
  };
  // END Fonction pour le trie dans le tableau

  // Fonction pour les modal New Simcarde Vehicules
  const handlOpenModalCreate = () => {
    fetchAffecteAOptions();
    setTitleModal(translate("New SIM card"));
    setSimcardOperator("");
    setSelectedUser("0");
    setSimCardNum("");
    setImeiNumber("");
    setContratType("");
    setSimcardType("");
    updatePhoneNumberPrefix("");
    setShowModal(true);
    setConfirmUpdate(false);
  };

  // Function pour ferme le Modal
  const handleCloseModal = () => {
    setShowModal(false);
    setShowDeletedModal(false);
    setConfirmUpdate(false);
    setErrorMessage("");
  };

  // Fumction Update And Duplicated Open Modal
  const handleUpdateAndDuplicatedClick = (
    simcardId: number,
    update: boolean
  ) => {
    // Get user option
    fetchAffecteAOptions();
    const selectedSimcard = simCardsList.find(
      (item) => item.id_puce === simcardId
    );

    if (selectedSimcard) {
      const operatorCode = getOperatorCode(
        selectedSimcard.operateur_puce,
        selectedSimcard.numero_puce
      );

      setSimcardOperator(operatorCode);
      updatePhoneNumberPrefix(operatorCode);
      setSelectedUser(selectedSimcard.id_user);
      setSelectedSimcardID(simcardId);
      setImeiNumber(selectedSimcard.serial_number || "");
      setContratType(selectedSimcard.contrat_puce || "");
      setSimcardType(selectedSimcard.type_puce || "");

      if (update) {
        setTitleModal(translate("Modifying a Simcard"));
        setSimCardNum(getPhoneSuffix(selectedSimcard.numero_puce, operatorCode));
        setShowModal(true);
        setConfirmUpdate(true);
      } else {
        setTitleModal(translate("Duplicate Simcard"));
        setSimCardNum("");
        setShowModal(true);
        setConfirmUpdate(false);
      }
    }
  };

  // Function Update Send Quary
  const handleConfirmUpdate = async () => {
    if (!simCardNum || !simcardOperator || !selectedUser || !contratType || !simcardType || !imeiNumber) {
      setErrorMessage(translate("Please complete all required fields."));
      return;
    }
    if (selectedUser === "0") {
      // Utilisateur non sélectionné
      setErrorMessage(translate("Please select a user."));
      return;
    }

    try {
      const response = await fetch(
        `${backendUrl}/api/simcards/update-simcard/${selectedSimcardID}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            numero_puce: "0" + simcardOperator + simCardNum,
            id_user: selectedUser,
            operateur_puce: getOperatorName(simcardOperator),
            type_puce: simcardType,
            contrat_puce: contratType,
            serial_number: imeiNumber,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`Erreur HTTP! Statut : ${response.status}`);
      }
      alert(`Simcard updated successfully`);
      setConfirmUpdate(false);
      refreshSimCardData();
      setShowModal(false);
    } catch (error) {
      console.error("Erreur lors de la mise à jour du simcard :", error);
    }
  };

  // Function Deleted
  const handleDeleteClick = async (idPuce: string) => {
    setSelectedSimcardID(parseInt(idPuce, 10));
    setShowDeletedModal(true);
  };

  const handleConfirmDelete = async () => {
    try {
      // Logique de suppression ici
      const loggedInuser_id = localStorage.getItem("userid");

      const response = await fetch(
        `${backendUrl}/api/simcards/softDeletesimcard/${selectedSimcardID}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ loggedInuser_id: loggedInuser_id }),
        }
      );

      if (!response.ok) {
        throw new Error(
          `Erreur lors de la suppression logique. Statut : ${response.status}`
        );
      }
      // Fermez le modal après la suppression
      setShowDeletedModal(false);
      refreshSimCardData();
      fetchDeletedSimCardCount();
    } catch (error) {
      console.error(error);
    }
  };

  // Fonction pour copier la color au click
  const handleClick = async (color: string) => {
    try {
      // Utiliser l'API Clipboard pour écrire le texte dans le presse-papiers
      await navigator.clipboard.writeText(color);

      // alert(`La couleur ${color} a été copiée avec succès!`);
    } catch (err) {
      console.error("Erreur lors de la copie dans le presse-papiers :", err);
    }
  };

  // fonction trash
  const fetchDeletedSimCardCount = async () => {
    try {
      const response = await fetch(
        `${backendUrl}/api/simcards/get-deleted-count/user/${user_id}`,
        { mode: "cors" }
      );

      if (!response.ok) {
        throw new Error(
          `Error fetching deleted users count. Status: ${response.status}`
        );
      }

      const data = await response.json();
      setDeletedSimcardCount(data.count);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchDeletedSimcards = async () => {
    try {
      const response = await fetch(
        `${backendUrl}/api/simcards/getDeleted/user/${user_id}`,
        { mode: "cors" }
      );

      if (!response.ok) {
        throw new Error(
          `Erreur lors de la récupération des simcards supprimés. Statut : ${response.status}`
        );
      }
      const data = await response.json();
      setDeletedSimcards(data);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des simcards supprimés :",
        error
      );
    }
  };

  const handleRestoreDeletedSimcard = async (id_puce: number) => {
    try {
      const response = await fetch(
        `${backendUrl}/api/simcards/restoreDeleted/${id_puce}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        throw new Error(
          `Erreur lors de la restauration du simcard supprimé. Statut : ${response.status}`
        );
      }
      fetchDeletedSimcards();
      refreshSimCardData();
      fetchDeletedSimCardCount();
    } catch (error) {
      console.error(
        "Erreur lors de la restauration du simcard supprimé :",
        error
      );
    }
  };
  //  fonction pour ouvrir le modal de simcards supprimés
  const handleOpenDeletedSimcardsModal = async () => {
    fetchDeletedSimcards();
    setShowDeletedSimcardsModal(true);
  };


  const Options = [
    "ID puce",
    "SIM card number",
    "Operator",
    "Creation date",
    "Contrat",
    "Serial number"
  ]


  const handleTypeSearch = (event: any) => {
    const selectedValue = event.target.textContent;
    switch (selectedValue) {
      case translate("ID puce"):
        setSelectedSearch(translate("ID puce"))
        setType(0);
        break;
      case translate("Type"):
        setSelectedSearch(translate("SIM card number"))
        setType(1);
        break;
      case translate("Operator"):
        setSelectedSearch(translate("Operator"))
        setType(2);
        break;
      case translate("Creation date"):
        setSelectedSearch(translate("Creation date"))
        setType(3);
        break;
      case translate("Contrat"):
        setSelectedSearch(translate("Contrat"))
        setType(4);
        break;
      case translate("Serial number"):
        setSelectedSearch(translate("Serial number"))
        setType(5);
        break;
      default:
        // console.log("Unknown selection");
        break;
    }

    setTypeSearch(selectedValue);
    console.log("Selected value:", selectedValue);
  };


  const handleAdvancedSearch = async (event: any) => {
    const newValue = event.target.value;
    setSearch(newValue);
    await getSimCards(limit, currentPage, newValue, type, column, sort);
  };


  


  return (
    <>
      <div className="row sim-page-header">
        <h4 className="col-sm-6 col-md-5 sim-page-title">
          <i
            className="las la-car mr-2"
            data-rel="bootstrap-tooltip"
            title={translate("Increased")}
          ></i>
          {translate("SIM cards")} ( {total} )
        </h4>
        <div className="col-sm-6 col-md-7 sim-header-actions">
          <a className="btn btn-outline-info sim-header-btn"
            onClick={handleOpenDeletedSimcardsModal}
          >
            <i className="las la-trash mr-2"></i>
            {translate("Deleted Simcards")} ( {deletedSimcardCount} )
          </a>
          <Link
            to="#"
            className="btn btn-primary sim-header-btn"
            onClick={handlOpenModalCreate}
          >
            <i className="las la-plus mr-2"></i>
            {translate("New SIM card")}
          </Link>
          <a href="#" className="btn btn-outline-secondary sim-header-btn">
            <i className="las la-file-import mr-2"></i>
            {translate("Import Simcards")}
          </a>
          <a href="#" className="btn btn-outline-info sim-header-btn">
            <i className="las la-download mr-2"></i>
            {translate("Download CSV")}
          </a>
        </div>
      </div>
      <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
        <div className="row">
          <div className="col-md-4" style={{ margin: "0px 0px 10px 0px", padding: "10px" }} >
            <div className="input-group">
              <Dropdown>
                <Dropdown.Toggle variant="link" id="dropdown-custom" className="custom-toggle">
                  <i
                    className="fas fa-chevron-down"
                    style={{ fontSize: "20" }}
                  ></i>
                </Dropdown.Toggle>
                <Dropdown.Menu onClick={handleTypeSearch}>
                  {Options.map(option => (
                    <Dropdown.Item
                      key={option}
                      className={`${selectedSearch == translate(option) ? 'active' : ''}`}
                      onClick={() => setSelectedSearch(translate(option))}
                    >
                      {translate(option)}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
              <input
                type="text"
                placeholder={`${translate("By")} ${selectedSearch}`}
                onChange={handleAdvancedSearch}
                className="form-control"
              />
            </div>
          </div>

          <div className="col-md-8 d-flex justify-content-end align-items-center">
            <div className="dataTables_length float-right">
              <label>
                {translate("Show")}
                <select
                  name="DataTables_Table_0_length"
                  aria-controls="DataTables_Table_0"
                  className="custom-select custom-select-sm form-control form-control-sm"
                  style={{ width: "66px" }}
                  value={limit}
                  onChange={(e) => {
                    setLimit(parseInt(e.target.value));
                    currentPage = 1;
                  }}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="500">500</option>
                </select>
                {translate("entries")}
              </label>
            </div>
          </div>

        </div>
      </div>
      <div>
        <div className="row m-2 sim-table-wrap">
          <Table className="simcards-table">
            <TableHeader />
            <tbody className="ligth-body">
              {loading ? (
                <tr style={{ textAlign: "center" }}>
                  <td className="text-center" colSpan={10}>
                    <p>
                      <PropagateLoader color={"#123abc"} loading={loading} size={20} />
                    </p>
                  </td>
                </tr>
              ) : sortedSimCardsList.length > 0 ? (
                sortedSimCardsList.map((item) => (
                  <tr className={`checkbox-${item.id_puce}`}>
                    <td>
                      <div className="checkbox d-inline-block">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`checkbox-${item.id_puce}`}
                        /*  checked={selectedSimCards.includes(item.id_puce.toString())}
                          onChange={() => handleSimCardSelect(item.id_puce.toString())}*/
                        />
                        <label htmlFor={`checkbox-${item.id_puce}`} className="mb-0"></label>
                      </div>
                    </td>
                    <td>{item.id_puce}</td>
                    <td>
                      <span className={`sim-operator-badge ${getOperatorBadgeClass(item.operateur_puce)}`}>
                        <i className="las la-sim-card"></i>
                        {item.operateur_puce || "-"}
                      </span>
                    </td>
                    <td>
                      <strong className="sim-phone">{item.numero_puce || "-"}</strong>
                    </td>
                    <td>
                      <span className="sim-contract-badge">{item.contrat_puce || "-"}</span>
                    </td>
                    <td>
                      <span className="sim-serial">{item.serial_number || "-"}</span>
                    </td>
                    <td className="text-center">
                      {new Date(item.date_creation_carte_sim).toLocaleDateString()}
                    </td>
                    <td>
                      <div className="d-flex align-items-center list-action">
                        <button
                          type="button"
                          className="sim-action-btn sim-action-copy"
                          title="Duplicate"
                          onClick={() => handleUpdateAndDuplicatedClick(item.id_puce, false)}
                        >
                          <i className="las la-copy"></i>
                        </button>
                        <button
                          type="button"
                          className="sim-action-btn sim-action-edit"
                          title="Update"
                          onClick={() => handleUpdateAndDuplicatedClick(item.id_puce, true)}
                        >
                          <i className="ri-pencil-line mr-0"></i>
                        </button>
                        <button
                          type="button"
                          className="sim-action-btn sim-action-delete"
                          title="Delete"
                          onClick={() => handleDeleteClick(item.id_puce.toString())}
                        >
                          <i className="ri-delete-bin-line mr-0"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={10} className="text-center sim-empty-state">
                    {translate("No SIM cards available")}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <div className="row">
          <div className="col-md-6 d-flex align-items-center">
            <span>
              {translate("Displaying")} {simCardsList.length} {translate("out of")}{" "}{total}
            </span>
          </div>
          <div className="col-md-6 d-flex justify-content-end">
            <ReactPaginate
              previousLabel={translate("previous")}
              nextLabel={translate("next")}
              breakLabel={"..."}
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-center"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName={"active"}
            />
          </div>
        </div>
      </div>

      {/* Modale de Creation*/}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="lg"
        centered
        dialogClassName="sim-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{titleModal}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* Première ligne */}
            <Row>
              <Col>
                <Form.Group controlId="formSimcardOperator">
                  <Form.Label>{translate("Operator")}</Form.Label>
                  <Form.Select
                    value={simcardOperator}
                    onChange={(e) => {
                      setSimcardOperator(e.target.value);
                      updatePhoneNumberPrefix(e.target.value);
                    }}
                    required
                  >
                    <option value="">{translate("Select an operator")}</option>
                    <option value="5">Ooredoo</option>
                    <option value="6">Mobilis</option>
                    <option value="7">Djezzy</option>{" "}
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* Champ Téléphone */}
              <Col>
                <Form.Group controlId="formPhoneNumber">
                  <Form.Label>{translate("Phone")}</Form.Label>
                  <InputGroup>
                    <InputGroup.Text id="phone-addon">
                      {phoneNumberPrefix}
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder={translate("Phone number")}
                      value={simCardNum}
                      onChange={(e) =>
                        setSimCardNum(e.target.value.replace(/\D/g, "").slice(0, 8))
                      }
                      pattern="[0-9]{8}"
                      title={translate("Please enter a valid 8-digit phone number")}
                      required
                    />
                  </InputGroup>
                </Form.Group>
              </Col>

              {/* Champ Nr. serie (IMEI) */}
            </Row>

            {/* Deuxième ligne */}
            <Row>
              <Col>
                <Form.Group controlId="formImeiNumber">
                  <Form.Label>{translate("IMEI")}</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={translate("IMEI number (15-17 digits)")}
                    value={imeiNumber}
                    onChange={(e) =>
                      setImeiNumber(e.target.value.replace(/\D/g, "").slice(0, 17))
                    }
                    pattern="[0-9]{15,17}"
                    title={translate("Please enter a valid IMEI number of 15 to 17 digits")}
                    required
                  />
                </Form.Group>
              </Col>
              {/* Champ Utilisateur */}
              <Col>
                <Form.Group controlId="formSimcardUser">
                  <Form.Label>{translate("User")}</Form.Label>
                  <Form.Select
                    value={selectedUser}
                    onChange={(e) => setSelectedUser(e.target.value)}
                    required
                  >
                    <option value="0">{translate("Select a user")}</option>
                    {affecteAOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* Champ Opérateur */}
            </Row>

            {/* Troisième ligne */}
            <Row>
              {/* Champ Type de SIM */}
              <Col>
                <Form.Group controlId="formSimcardType">
                  <Form.Label>{translate("SIM Type")}</Form.Label>
                  <Form.Select
                    value={simcardType}
                    onChange={(e) => setSimcardType(e.target.value)}
                    required
                  >
                    <option value="">{translate("Select SIM type")}</option>
                    <option value="carteSIM">{translate("SIM Card")}</option>
                    <option value="SIMInterne">
                      {translate("Internal SIM")}
                    </option>
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* Champ Contrat */}
              <Col>
                <Form.Group controlId="formContratType">
                  <Form.Label>{translate("Contract Type")}</Form.Label>
                  <Form.Select
                    value={contratType}
                    onChange={(e) => setContratType(e.target.value)}
                    required
                  >
                    <option value="">
                      {translate("Select contract type")}
                    </option>
                    <option value="Prepaye">{translate("Prepaid")}</option>
                    <option value="Abonnement">
                      {translate("Subscription")}
                    </option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between">
          <div className="d-flex flex-column align-items-center m-auto">
            {errorMessage && (
              <div className="sim-form-error">
                {errorMessage}
              </div>
            )}
          </div>
          <div className="d-flex">
            <Button
              variant="danger"
              onClick={handleCloseModal}
              className="me-2"
            >
              {translate("Cancel")}
            </Button>
            <Button
              variant="success"
              onClick={
                confirmUpdate ? handleConfirmUpdate : handleConfirmSaveModal
              }
            >
              <i className="las la-save mr-1"></i>
              {translate("Save")}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      {/* Modal delete */}
      <Modal show={showDeletedModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>{translate("Delete confirmation")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {translate("Are you sure you want to delete this SIM card?")}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            {translate("Cancel")}
          </Button>
          <Button variant="danger" onClick={handleConfirmDelete}>
            {translate("Delete")}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* trash */}
      <Modal
        show={showDeletedSimcardsModal}
        onHide={() => setShowDeletedSimcardsModal(false)}
        dialogClassName="modal-lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">
            {translate("Deleted Simcards")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Display the list of deleted groups in a table */}
          <table className="table">
            <thead>
              <tr>
                <th style={{ color: "#140A57" }}>{translate("id")}</th>
                <th className="text-center" style={{ color: "#140A57" }}>
                  {translate("Phone")}
                </th>
                <th className="text-center" style={{ color: "#140A57" }}>
                  {translate("Operator")}
                </th>
                <th className="text-center" style={{ color: "#140A57" }}>
                  {translate("Serial number")}
                </th>
                <th className="text-right" style={{ color: "#140A57" }}>
                  {translate("Actions")}
                </th>
              </tr>
            </thead>
            <tbody>
              {deletedSimcards.map((simcard) => (
                <tr key={simcard.id_puce}>
                  <td>{simcard.id_puce}</td>
                  <td className="text-center">{simcard.numero_puce}</td>
                  <td className="text-center">{simcard.operateur_puce}</td>
                  <td className="text-center">{simcard.serial_number}</td>

                  <td className="text-right">
                    <Button
                      variant="success"
                      className=""
                      onClick={() =>
                        handleRestoreDeletedSimcard(simcard.id_puce)
                      }
                    >
                      <i className="las la-trash-restore">
                        {" "}
                        {translate("Restore")}
                      </i>
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={() => setShowDeletedSimcardsModal(false)}
          >
            {translate("Close")}
          </Button>
        </Modal.Footer>
      </Modal>
      {/* END trash */}
    </>
  );
}
